export default {
  title: "Add Attachment",
  body: "Do you wish to upload a new file or search the list of existing <b class='text-info'>Attachments</b> and attach an existing file?",
  hint: "<b>Hint:</b> Press outside the dialogue to do neither / cancel.",
  subtitle: "Add <b class='text-info'>Attachment</b> to <b class='text-info'>{entity}</b>",
  notification_no_attachments:
    "There are no other Attachments for you to choose from. You can use the Upload new file button or drag and drop files",
}
